export default __webpack_public_path__ + "media/images/mastodon-ui-6dc9f45a2b74c069ecd4210d4f3a42b3.png";